
/**
 * 首页容器
 */
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { TabDto } from '@/api/goodsModule';
import { isOpenStore } from '@/api/ccx'
import more from './tabbar-more/index.vue';
import OpenStorePop from '@/components/openCCXStorePopup/OpenStorePop.vue';
import SuccessOpenStorePop from '@/components/openCCXStorePopup/SuccessOpenStorePop.vue';
Component.registerHooks(['beforeRouteUpdate'])

@Component({
  name: 'ShopHomeLayout',
  components: {
    more,
    OpenStorePop,
    SuccessOpenStorePop
  },
})
export default class ShopHomeLayout extends Vue {
  @Getter includedComponents: string[];
  @Getter info: any; // 用户信息
  @Getter routerAliveStatus;
  @Getter tabModules!: Array<TabDto>;
  @Getter companyId!: string;
  include = [];

  active = '/mall';
  tabbarZIndex = 1; // 当more组件显示为9999，关闭为1

  $refs: {
    moreRef: more,
    openStorePopRef: OpenStorePop
    successOpenStorePopRef: SuccessOpenStorePop
  }

  @Watch('$route')
  handleRouteChange(to: any, from: any) {
    if (this.isShowBottomTab) {
      console.log(
        '🚀 ~ ShopHomeLayout ~ handleRouteChange ~ this.isShowBottomTab:',
        this.isShowBottomTab
      );
      const paths = this.handledTabs.map((i) => i.route)
      if ([...paths, '/shopMallOrder'].includes(to.path)) {
        this.active = to.path
      } else {
        this.active = '/more'
      }
    }
  }

  get isShow() {
    return this.info.currentVersionCode !== 'system';
    // return true
  }

  get isShowBottomTab() {
    const paths = this.handledTabs.map((i) => i.route);
    // return [...paths, '/shopMallOrder'].includes(this.$route.path);
    return ['/mall','/mallCategory', '/buyMallCar', '/goods', '/shelf', '/salesSlip', '/salespromotion', '/salesstatistics', '/shopMallOrder'].includes(this.$route.path);
  }

  get handledTabs() {
    return this.tabModules.filter((t) => t.isShow);
  }

  async beforeRouteUpdate(to, from, next) {
    // 当进入我的货架、销售单、促销活动、销售统计页面，需判断用户是否开通常常鲜店铺
    const paths = ['/shelf', '/salesSlip', '/salespromotion', '/salesstatistics']
    if (paths.includes(to.path)) {
      // 是否开通店铺
      const { data } = await isOpenStore({ storeId: this.companyId })
      // 0未开通1开通
      if (data.isopenstore === 0) {
        // 弹去开通弹窗
        this.$refs.openStorePopRef.showPopup()
        this.active = from.path
        next(false)
      } else {
        next()
      }
    } else {
      next()
    }
  }

  onChange(active) {
    // console.log('onChange', active);
    // this.active = active;
  }

  created() {
    this.include = this.includedComponents;
    // console.log('app-====',this.routerAliveStatus);
    this.active = this.$route.path;
    this.$eventBus.$on('isSuccessOpenStore',()=>{
      this.$refs.successOpenStorePopRef.showPopup()
    })
  }

  destroyed () {
    this.$eventBus.$off('isSuccessOpenStore')
  }

  toMore() {
    (this.$refs.moreRef as any).show();
  }

  onMoreIsShow(bool) {
    // 当more组件显示为9999，关闭为1
    setTimeout(() => {
      this.tabbarZIndex = bool ? 9999 : 1
    }, bool ? 0 : 300)
  }
}
